import { render, staticRenderFns } from "./testtt.vue?vue&type=template&id=7cd567fc&scoped=true&"
import script from "./testtt.vue?vue&type=script&lang=js&"
export * from "./testtt.vue?vue&type=script&lang=js&"
import style0 from "./testtt.vue?vue&type=style&index=0&id=7cd567fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd567fc",
  null
  
)

export default component.exports